import * as React from 'react';
import * as ReactDOM from 'react-dom';
import AddToCart from '../../Components/Cart/Components/AddToCart/AddToCart';
import CartHeaderIcon from '../../Components/Cart/Components/CartHeaderIcon';
import CartContainer from '../../Components/Cart/Container/CartContainer';

import { clearDomContainer } from '../Utils';

const slideInContainer = document.getElementById('js-slide-in-cart-dom-integration');
const headerCartContainer = document.querySelectorAll('.js-header-cart') as NodeListOf<HTMLElement>;
const loggedOutAddToCartContainer = document.querySelectorAll('.js-add-to-cart-logged-out') as NodeListOf<HTMLElement>;

if (slideInContainer) {
    clearDomContainer(slideInContainer);
}

const CartIntegrations = () => {
    if (headerCartContainer.length > 0 || slideInContainer) {
        return (
            <>
                {slideInContainer && ReactDOM.createPortal(<CartContainer />, slideInContainer)}
                {[...headerCartContainer].map((container) => {
                    clearDomContainer(container);
                    return ReactDOM.createPortal(<CartHeaderIcon />, container);
                })}

                {/* This integration is only loaded for logged out users */}
                {/* Otherwise the add-to-cart button is part of the ProductActionsIntegrations */}
                {[...loggedOutAddToCartContainer].map((container) => {
                    clearDomContainer(container);
                    const parent = container.parentElement as HTMLElement;
                    const article = parent.dataset.article && JSON.parse(parent.dataset.article);
                    const onlyOrderButton = parent.dataset.onlyOrderButton === 'true';
                    return ReactDOM.createPortal(
                        <AddToCart article={article} hideQuantity={onlyOrderButton} />,
                        container,
                    );
                })}
            </>
        );
    }

    return null;
};

export default CartIntegrations;
